import { createSelector } from 'reselect'
import { selectCurrentTicketId } from 'selectors/tickets/current/selectCurrentTicketId'
import { selectTicketDraft } from 'ducks/drafts'
import { reverse } from 'util/arrays'
import { normalizeAttachment } from 'util/file'
import { selectAttachmentsByTicketId } from './base'

const emptyArray = []

export const selectUploadingAttachmentsForCurrentTicket = createSelector(
  selectAttachmentsByTicketId,
  selectCurrentTicketId,
  (byTicketId, ticketId) => {
    const attachments = byTicketId[ticketId]
    if (!attachments) return emptyArray
    return Object.values(byTicketId[ticketId]).map(normalizeAttachment)
  }
)

export const selectTicketDraftAttachments = createSelector(
  selectUploadingAttachmentsForCurrentTicket,
  selectTicketDraft,
  (uploadingAttachments, draft) => {
    if (!draft || !draft.attachments) return uploadingAttachments
    const uploadedAttachments = Object.values(draft.attachments).map(
      normalizeAttachment
    )
    return [...uploadingAttachments, ...reverse(uploadedAttachments)]
  }
)
